export default "__VITE_ASSET__CScLr683__"